// Maps the site's chosen theme font (ACF 'chosen_font' field) to the CSS
// font-family name loaded by the client app's own _config.scss, so "System"
// font choices in the social media generator match the theme's actual font.
const THEME_FONT_FAMILIES = {
    roboto:   'robotomedium',
    affogato: 'affogatomedium',
    hind:     'hindregular',
    poppins:  'poppinsregular',
    circular: 'circularmedium',
    jost:     'jostregular',
    avenir:   'avenirmedium',
    carbon:   'carbonregular',
}

export default THEME_FONT_FAMILIES
